import Avatar from './ui/Avatar'
import { BadgeCheck } from 'lucide-react'

interface PostHeaderProps {
  author: {
    name: string
    username: string
    avatar?: string
    verified?: boolean
  }
  onRecordCode?: string
  timestamp?: string
  showAvatar?: boolean
  avatarSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
  textColor?: 'dark' | 'light'
  onUserClick?: () => void
}

export default function PostHeader({
  author,
  onRecordCode,
  timestamp,
  showAvatar = true,
  avatarSize = 'md',
  textColor = 'dark',
  onUserClick,
}: PostHeaderProps) {
  // Handle missing author data gracefully
  if (!author) {
    return null
  }

  const nameColor = textColor === 'light' ? 'var(--smoke)' : 'var(--smoke)'
  const handleColor = textColor === 'light' ? 'var(--silver)' : 'var(--silver)'
  const codeColor = textColor === 'light' ? 'var(--silver)' : 'var(--silver)'

  return (
    <div className="flex items-start gap-3">
      {/* Avatar */}
      {showAvatar && (
        <Avatar
          src={author?.avatar}
          alt={author?.name || 'User'}
          size={avatarSize}
          onClick={onUserClick}
          className={onUserClick ? 'cursor-pointer' : ''}
        />
      )}

      {/* User Info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span
            className={`font-bold text-[15px] text-gray-900 ${onUserClick ? 'hover:underline cursor-pointer' : ''}`}
            onClick={(e) => { if (onUserClick) { e.stopPropagation(); onUserClick() } }}
          >
            {author?.name || 'Anonymous'}
          </span>
          {author?.verified && (
            <BadgeCheck className="w-[18px] h-[18px]" style={{ color: 'white', fill: '#1DA1F2' }} />
          )}
          <span
            className={`text-[15px] text-gray-500 ${onUserClick ? 'hover:underline cursor-pointer' : ''}`}
            onClick={(e) => { if (onUserClick) { e.stopPropagation(); onUserClick() } }}
          >
            @{author?.username || 'anonymous'}
          </span>
          {timestamp && (
            <>
              <span className="text-gray-500">·</span>
              <span className="text-[15px] text-gray-500">
                {timestamp}
              </span>
            </>
          )}
        </div>

        {/* on record Code */}
        {onRecordCode && (
          <div className="text-[13px] font-mono text-gray-500 mt-0.5">
            {onRecordCode}
          </div>
        )}
      </div>
    </div>
  )
}
